// extracted by mini-css-extract-plugin
module.exports = {"createButton":"CreateAdSpend_createButton__jRsaj","formItem":"CreateAdSpend_formItem__3ufY0","buttonsContainer":"CreateAdSpend_buttonsContainer__3slru"};